import type { ComponentType } from 'react'

export type ProjectFlowProps = {
  projectId: string
  projectName: string
  language: string
  pointsAmount?: number
  onBack: () => void
  onCompleted: () => void
}

/**
 * Project types with custom multi-step flows register here.
 * Types NOT in this registry fall through to NectarTaskContent (standard task-by-task).
 */
export const PROJECT_FLOW_COMPONENTS = new Map<string, ComponentType<ProjectFlowProps>>()
